import { OfferModel } from '@/logic/services/offers';
import { ValidationTypes } from '@/constants/offers';

export function getOfferTitle(offer: OfferModel) {
  const temp = checkIsBankOffer(offer)
    ? [offer?.bankName, offer?.title]
    : [offer?.title, offer?.hint];

  return temp.filter(w => !!w).join(' - ');
}

export function checkIsBankOffer(offer: OfferModel) {
  return offer?.validationType === ValidationTypes.BIN;
}

export function checkIsUnipalOffer(offer: OfferModel) {
  return offer?.validationType === ValidationTypes.UNI_PAL;
}

export function checkIsNoneOffer(offer: OfferModel) {
  return offer?.validationType === ValidationTypes.NONE;
}

export function checkIsCardOffer(offer: OfferModel) {
  return offer?.validationType === ValidationTypes.CARD;
}
